export default [
    {
        path: '/clients',
        name: 'clients',
        component: () => import('@/views/cromis/clients/Client.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Clients',
                }
            ],
        }
    },
    {
        path: '/locations',
        name: 'locations',
        component: () => import('@/views/cromis/locations/Location.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Locations',
                }
            ],
        }
    },
    {
        path: '/buyers',
        name: 'buyers',
        component: () => import('@/views/cromis/buyers/Buyer.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Buyers',
                }
            ],
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('@/views/cromis/orders/Order.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Tickets Orders',
                }
            ],
        }
    },
    {
        path: '/clerks',
        name: 'clerks',
        component: () => import('@/views/cromis/clerks/Clerks.vue'),
        meta: {
            pageTitle: 'Clerks',
            breadcrumb: [
                {
                    text: 'Clerks',
                }
            ],
        }
    },
    {
        path: '/classifire',
        name: 'classifire',
        component: () => import('@/views/cromis/classifire/Classifier.vue'),
        meta: {
            pageTitle: 'Classifier',
            breadcrumb: [
                {
                    text: 'Classifires',
                }
            ],
        }
    },
    {
        path: '/markets',
        name: 'markets',
        component: () => import('@/views/cromis/markets/Market.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Market Centers',
                }
            ],
        }
    },
    {
        path: '/seasons',
        name: 'seasons',
        component: () => import('@/views/cromis/season/Season.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Seasons',
                },
            ],
        },
    },
    {
        path: '/estimates',
        name: 'estimates',
        component: () => import('@/views/cromis/estimates/Estimates.vue'),
        meta: {
            pageTitle: 'Administration',
            breadcrumb: [
                {
                    text: 'Crop Estimates',
                },
            ],
        },
    },
    {
        path: '/societies',
        name: 'societies',
        component: () => import('@/views/cromis/society/Society.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Societies',
                },
            ],
        },
    },
    {
        path: '/societies/:id',
        name: 'societies',
        component: () => import('@/views/cromis/society/SocietyView.vue'),
        meta: {
            pageTitle: 'View',
            breadcrumb: [
                {
                    text: 'Society',
                },
            ],
        },
    },
    {
        path: '/growers',
        name: 'growers',
        component: () => import('@/views/cromis/grower/Grower.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Growers',
                },
            ],
        },
    },
    {
        path: '/growers/:id',
        name: 'growers',
        component: () => import('@/views/cromis/grower/GrowerView.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Grower Facilities',
                },
            ],
        },
    },
    {
        path: '/sectors',
        name: 'sectors',
        component: () => import('@/views/cromis/sectors/Sector.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Sectors',
                }
            ],
        }
    },
    {
        path: '/clubs',
        name: 'clubs',
        component: () => import('@/views/cromis/clubs/Club.vue'),
        meta: {
            pageTitle: 'Registration',
            breadcrumb: [
                {
                    text: 'Clubs',
                }
            ],
        }
    },
    {
        path: '/countries',
        name: 'countries',
        component: () => import('@/views/cromis/countries/Country.vue'),
        meta: {
            pageTitle: 'Registation',
            breadcrumb: [
                {
                    text: 'Countries',
                }
            ],
        }
    },
    {
        path: '/companies',
        name: 'companies',
        component: () => import('@/views/cromis/companies/Company.vue'),
        meta: {
            pageTitle: 'Registation',
            breadcrumb: [
                {
                    text: 'Companies',
                }
            ],
        }
    },
    {
        path: '/grades_group',
        name: 'grades_group',
        component: () => import('@/views/cromis/grades/grade_groups/GradeGroups.vue'),
        meta: {
            pageTitle: 'Grade Groups',
            breadcrumb: [
                {
                    text: 'Grade Grades',
                }
            ],
        }
    },
    {
        path: '/crop_grades',
        name: 'crop_grades',
        component: () => import('@/views/cromis/grades/crop_grades/Grade.vue'),
        meta: {
            pageTitle: 'Registation',
            breadcrumb: [
                {
                    text: 'Crop Grades',
                }
            ],
        }
    },
    {
        path: '/units',
        name: 'units',
        component: () => import('@/views/cromis/units/Unit.vue'),
        meta: {
            pageTitle: 'Registation',
            breadcrumb: [
                {
                    text: 'Units Measurements',
                }
            ],
        }
    },
    {
        path: '/grower_inputs',
        name: 'grower_inputs',
        component: () => import('@/views/cromis/inputs/Input.vue'),
        meta: {
            pageTitle: 'Registation',
            breadcrumb: [
                {
                    text: 'Grower Inputs',
                }
            ],
        }
    },
    {
        path: "/grower_inputs/:id",
        name: "grower_inputs",
        component: () => import("@/views/cromis/inputs/InputView.vue"),
        meta: {
          pageTitle: "Loan Management",
          breadcrumb: [
            {
              text: "Input Prices",
            },
          ],
        },
      },

    // Market Sales
    {
        path: '/sales',
        name: 'sales',
        component: () => import('@/views/cromis/sales/sale/Sale.vue'),
        meta: {
            pageTitle: 'Market Sales',
            breadcrumb: [
                {
                    text: 'Register Sales',
                }
            ],
        }
    },
    {
        path: '/sale_close',
        name: 'sale_close',
        component: () => import('@/views/cromis/sales/sale_close/SaleClose.vue'),
        meta: {
            pageTitle: 'Market Sales',
            breadcrumb: [
                {
                    text: 'Sale Close',
                }
            ],
        }
    },
    {
        path: '/reverse_sale',
        name: 'reverse_sale',
        component: () => import('@/views/cromis/sales/reverse/ReverseSale.vue'),
        meta: {
            pageTitle: 'Market Sales',
            breadcrumb: [
                {
                    text: 'Reverse Sale',
                }
            ],
        }
    },
    {
        path: '/purchase_data',
        name: 'purchase_data',
        component: () => import('@/views/cromis/sales/purchase_data/PurchaseData.vue'),
        meta: {
            pageTitle: 'Purchase Data',
            breadcrumb: [
                {
                    text: 'Purchase Data Export',
                }
            ],
        }
    },
    {
        path: '/agreements',
        name: 'agreements',
        component: () => import('@/views/cromis/sales/agreement/Agreement.vue'),
        meta: {
            pageTitle: 'Market Sales',
            breadcrumb: [
                {
                    text: 'Purchase Contracts',
                }
            ],
        }
    },
    {
        path: '/tickets',
        name: 'tickets',
        component: () => import('@/views/cromis/sales/tickets/Ticket.vue'),
        meta: {
            pageTitle: 'Market Sales',
            breadcrumb: [
                {
                    text: 'Ticket Capturing',
                }
            ],
        }
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: () => import('@/views/cromis/sales/tickets/Transaction.vue'),
        meta: {
            pageTitle: 'Ticket',
            breadcrumb: [
                {
                    text: 'Transactions',
                }
            ],
        }
    },
    {
        path: '/inline_buying',
        name: 'inline_buying',
        component: () => import('@/views/cromis/buying/Inline.vue'),
        meta: {
            pageTitle: 'Buying',
            breadcrumb: [
                {
                    text: 'Inline Buying',
                }
            ],
        }
    },
    {
        path: '/bale_reclassifiction',
        name: 'bale_reclassifiction',
        component: () => import('@/views/cromis/buying/reclassification/Reclassification.vue'),
        meta: {
            pageTitle: 'Buying',
            breadcrumb: [
                {
                    text: 'Bale Reclassification',
                }
            ],
        }
    },

    {
        path: '/requisitions',
        name: 'requisitions',
        component: () => import('@/views/cromis/sales/requisition/Requisition.vue'),
        meta: {
            pageTitle: 'Requisitions',
            breadcrumb: [
                {
                    text: 'Requisition Details',
                }
            ],
        }
    },

    {
        path: '/receive_pcn',
        name: 'receive_pcn',
        component: () => import('@/views/cromis/sales/receive_pcn/ReceivePcn.vue'),
        meta: {
            pageTitle: 'PCN',
            breadcrumb: [
                {
                    text: 'Receive PCN',
                }
            ],
        }
    },
    {
        path: '/sale_documents',
        name: 'sale_documents',
        component: () => import('@/views/cromis/sales/sales_documents/SalesDocuments.vue'),
        meta: {
            pageTitle: 'Sales Documents',
            breadcrumb: [
                {
                    text: 'Print',
                }
            ],
        }
    },


    //Inventory Menus
    {
        path: '/grower_tags',
        name: 'grower_tags',
        component: () => import('@/views/cromis/inventory/tags/GrowerTags.vue'),
        meta: {
            pageTitle: 'Inventory',
            breadcrumb: [
                {
                    text: 'Grower Tags',
                }
            ],
        }
    },
    {
        path: '/boxes',
        name: 'boxes',
        component: () => import('@/views/cromis/inventory/box/Box.vue'),
        meta: {
            pageTitle: 'Inventory',
            breadcrumb: [
                {
                    text: 'Ticket Boxes',
                }
            ],
        }
    },
    {
        path: '/recieve_box',
        name: 'recieve_box',
        component: () => import('@/views/cromis/inventory/ticket_box/TicketBox.vue'),
        meta: {
            pageTitle: 'Inventory',
            breadcrumb: [
                {
                    text: 'Receive Ticket Boxes',
                }
            ],
        }
    },

    // Transportation Menus
    {
        path: '/transporters',
        name: 'transporters',
        component: () => import('@/views/cromis/transportations/transporter/Transporter.vue'),
        meta: {
            pageTitle: 'Transportation',
            breadcrumb: [
                {
                    text: 'Transporter Information',
                }
            ],
        }
    },

    {
        path: '/fleets',
        name: 'fleets',
        component: () => import('@/views/cromis/transportations/fleet/Fleet.vue'),
        meta: {
            pageTitle: 'Fleets',
            breadcrumb: [
                {
                    text: 'Fleets Information',
                }
            ],
        }
    },

    {
        path: '/drivers',
        name: 'drivers',
        component: () => import('@/views/cromis/transportations/driver/Driver.vue'),
        meta: {
            pageTitle: 'Driver',
            breadcrumb: [
                {
                    text: 'Drivers Information',
                }
            ],
        }
    },



    // Warehouse Menus

    {
        path: '/storage_layouts',
        name: 'storage_layouts',
        component: () => import('@/views/cromis/warehouse/storage_layouts/StorageLayouts.vue'),
        meta: {
            pageTitle: 'Storage Layout',
            breadcrumb: [
                {
                    text: 'Storage Layout',
                }
            ],
        },
    },

    {
        path: '/warehouses',
        name: 'warehouses',
        component: () => import('@/views/cromis/warehouse/warehouse/Warehouse.vue'),
        meta: {
            pageTitle: 'Warehouses',
            breadcrumb: [
                {
                    text: 'Warehouse Information',
                }
            ],
        },
    },

    {
        path: '/warehouses/:id',
        name: 'warehouses',
        component: () => import('@/views/cromis/warehouse/warehouse/WarehouseView.vue'),
        meta: {
            pageTitle: 'Stack Management',
            breadcrumb: [
                {
                    text: 'Stack Management',
                },
            ],
        },
        props: true 
    },

    {
        path: '/stack_grade',
        name: 'stack_grade',
        component: () => import('@/views/cromis/warehouse/stack_grade/StackGrade.vue'),
        meta: {
            pageTitle: 'Stack Grade',
            breadcrumb: [
                {
                    text: 'Grades Association',
                }
            ],
        }
    },

    {
        path: '/routes',
        name: 'routes',
        component: () => import('@/views/cromis/warehouse/route/Route.vue'),
        meta: {
            pageTitle: 'Routes',
            breadcrumb: [
                {
                    text: 'Routes Information',
                }
            ],
        }
    },

    {
        path: '/stack_summary',
        name: 'stack_summary',
        component: () => import('@/views/cromis/warehouse/stack_summary/StackSummary.vue'),
        meta: {
            pageTitle: 'Stack Summary',
            breadcrumb: [
                {
                    text: 'Stack Information',
                }
            ],
        }
    },


        // Green Shipping Menus
        {
            path: '/long_haul',
            name: 'long_haul',
            component: () => import('@/views/cromis/green_shipping/long_haul/LongHaul.vue'),
            meta: {
                pageTitle: 'Warehouse To Warehouse',
                breadcrumb: [
                    {
                        text: 'Warehouse Information',
                    }
                ],
            }
        },
        {
            path: '/short_haul',
            name: 'short_haul',
            component: () => import('@/views/cromis/green_shipping/short_haul/ShortHaul.vue'),
            meta: {
                pageTitle: 'Socities To MC',
                breadcrumb: [
                    {
                        text: 'Socities To MC Information',
                    }
                ],
            }
        },
        {
            path: '/bulk_shipment',
            name: 'bulk_shipment',
            component: () => import('@/views/cromis/green_shipping/bulk_shipment/BulkShipment.vue'),
            meta: {
                pageTitle: 'Bulk Transfer',
                breadcrumb: [
                    {
                        text: 'Bulk Transfer',
                    }
                ],
            }
        },
        {
            path: '/tobacco_shipment',
            name: 'tobacco_shipment',
            component: () => import('@/views/cromis/green_shipping/tobacco_shipment/TobaccoShipment.vue'),
            meta: {
                pageTitle: 'Tobacco Shipment',
                breadcrumb: [
                    {
                        text: 'Shippment',
                    }
                ],
            }
        },
        {
            path: '/check_barcode',
            name: 'check_barcode',
            component: () => import('@/views/cromis/green_shipping/check_tf/CheckTf.vue'),
            meta: {
                pageTitle: 'Check TF Data',
                breadcrumb: [
                    {
                        text: 'Shippment',
                    }
                ],
            }
        },

    // Dry Shipping Menus
    {
        path: '/shipments',
        name: 'shipments',
        component: () => import('@/views/cromis/shipping/shipments/Shipment.vue'),
        meta: {
            pageTitle: 'Dry Shipping',
            breadcrumb: [
                {
                    text: 'Shipment Information',
                }
            ],
        }
    },
    {
        path: '/queue',
        name: 'queue',
        component: () => import('@/views/cromis/queue/Queue.vue'),
        meta: {
            pageTitle: 'Green Shipping',
            breadcrumb: [
                {
                    text: 'Yard Queuing',
                }
            ],
        }
    },
    {
        path: '/consignments',
        name: 'consignments',
        component: () => import('@/views/cromis/shipping/consignments/Consignment.vue'),
        meta: {
            pageTitle: 'Dry Shipping',
            breadcrumb: [
                {
                    text: 'Consignments',
                }
            ],
        }
    },
    {
        path: '/ports',
        name: 'ports',
        component: () => import('@/views/cromis/shipping/ports/Port.vue'),
        meta: {
            pageTitle: 'Dry Shipping',
            breadcrumb: [
                {
                    text: 'Ports',
                }
            ],
        }
    },
    {
        path: '/vessels',
        name: 'vessels',
        component: () => import('@/views/cromis/shipping/vessels/Vessel.vue'),
        meta: {
            pageTitle: 'Dry Shipping',
            breadcrumb: [
                {
                    text: 'Vessels',
                }
            ],
        }
    },

    {
        path: '/groups',
        name: 'groups',
        component: () => import('@/views/cromis/role/Group.vue'),
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'User Groups',
                },
            ],
        },
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/views/cromis/users/User.vue'),
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'Users Accounts',
                }
            ],
        }
    },
    {
        path: '/groups',
        name: 'groups',
        component: () => import('@/views/cromis/role/Group.vue'),
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'User Groups',
                },
            ],
        },
    },
    {
        path: '/stations',
        name: 'stations',
        component: () => import('@/views/cromis/station/WorkStation.vue'),
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'Users Work Stations',
                }
            ],
        }
    },
    {
        path: '/stations/:id',
        name: 'stations',
        component: () => import('@/views/cromis/station/view/WorkStationView.vue'),
        props: true,
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'Station User Allocation',
                },
            ],
        },
    },
    {
        path: '/printers',
        name: 'printers',
        component: () => import('@/views/cromis/printer/Printer.vue'),
        meta: {
            pageTitle: 'System Security',
            breadcrumb: [
                {
                    text: 'Printers',
                }
            ],
        }
    },

    {
        path: '/projects',
        name: 'projects',
        component: () => import('@/views/cromis/visitings/projects/Project.vue'),
        meta: {
            pageTitle: 'Field Vistings',
            breadcrumb: [
                {
                    text: 'Projects',
                }
            ],
        }
    },
    {
        path: '/questionnaires',
        name: 'questionnaires',
        component: () => import('@/views/cromis/visitings/questionnaires/Questionnaire.vue'),
        meta: {
            pageTitle: 'Field Vistings',
            breadcrumb: [
                {
                    text: 'Questionnaires',
                }
            ],
        }
    },
    {
        path: '/questions',
        name: 'questions',
        component: () => import('@/views/cromis/visitings/questions/Question.vue'),
        meta: {
            pageTitle: 'Field Vistings',
            breadcrumb: [
                {
                    text: 'Questions',
                }
            ],
        }
    },

    // Reports
    {
        path: '/sales_report',
        name: 'sales_report',
        component: () => import('@/views/cromis/reports/sales_report/SalesReport.vue'),
        meta: {
            pageTitle: 'Sales Report',
            breadcrumb: [
                {
                    text: 'Sales Report',
                }
            ],
        }
    },
    {
        path: '/stock_position',
        name: 'stock_position',
        component: () => import('@/views/cromis/reports/stock_position/StockPosition.vue'),
        meta: {
            pageTitle: 'Stock Position',
            breadcrumb: [
                {
                    text: 'Stock Position',
                }
            ],
        }
    },
    {
        path: '/villages_sale_summary',
        name: 'villages_sale_summary',
        component: () => import('@/views/cromis/reports/villages_summary/VillagesSummary.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Village Sale Summary Report',
                }
            ],
        }
    },
    {
        path: '/markets_sale_summary',
        name: 'markets_sale_summary',
        component: () => import('@/views/cromis/reports/markets_summary/MarketsSummary.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Markets Sale Summary Report',
                }
            ],
        }
    },
    {
        path: '/village_sales',
        name: 'village_sales',
        component: () => import('@/views/cromis/reports/village_sale/VillageSales.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Taarifa ya Soko',
                }
            ],
        }
    },
    {
        path: '/village_season_sales',
        name: 'village_season_sales',
        component: () => import('@/views/cromis/reports/village_season_sale/VillageSeasonSales.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Village Season Sales',
                }
            ],
        }
    },
    {
        path: '/payment_schedule',
        name: 'payment_schedule',
        component: () => import('@/views/cromis/reports/schedule/PaymentSchedule.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Payment Schedule',
                }
            ],
        }
    },
    {
        path: '/grower_voucher',
        name: 'grower_voucher',
        component: () => import('@/views/cromis/reports/voucher/GrowerVoucher.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Hati ya Mauzo ya Mkulima',
                }
            ],
        }
    },
    {
        path: '/sales_bonus',
        name: 'sales_bonus',
        component: () => import('@/views/cromis/reports/bonus/Bonus.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Sales Bonus',
                }
            ],
        }
    },
    {
        path: '/sales_progress',
        name: 'sales_progress',
        component: () => import('@/views/cromis/reports/progress/Progress.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Sales Progress',
                }
            ],
        }
    },
    {
        path: '/purchase_contracts',
        name: 'purchase_contracts',
        component: () => import('@/views/cromis/reports/pcns/PurchaseContract.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Purchase Contracts Notes',
                }
            ],
        }
    },
    {
        path: '/sale_summary',
        name: 'sale_summary',
        component: () => import('@/views/cromis/reports/sale_summary/SaleSummary.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Market Sale Summary',
                }
            ],
        }
    },
    {
        path: '/attachments',
        name: 'attachments',
        component: () => import('@/views/cromis/reports/attachments/Attachment.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Shipping Attachments',
                }
            ],
        }
    },
    {
        path: '/agronomy_extracts',
        name: 'agronomy_extracts',
        component: () => import('@/views/cromis/reports/agronomy/AgronomyExtracts.vue'),
        meta: {
            pageTitle: 'Reports',
            breadcrumb: [
                {
                    text: 'Agronomy Extracts',
                }
            ],
        }
    },

    // Demo Filters
    {
        path: '/filters',
        name: 'filters',
        component: () => import('@/views/cromis/filters/Filters.vue'),
        meta: {
            pageTitle: 'Demo',
            breadcrumb: [
                {
                    text: 'Location Filters',
                }
            ],
        }
    },

    // Payments
    {
        path: '/banks',
        name: 'banks',
        component: () => import('@/views/cromis/payments/bank/Bank.vue'),
        meta: {
            pageTitle: 'Payments',
            breadcrumb: [
                {
                    text: 'Banks',
                }
            ],
        }
    },
    {
        path: '/deductions',
        name: 'deductions',
        component: () => import('@/views/cromis/payments/deductions/Deduction.vue'),
        meta: {
            pageTitle: 'Payments',
            breadcrumb: [
                {
                    text: 'Deductions',
                }
            ],
        }
    },
    {
        path: '/payments',
        name: 'payments',
        component: () => import('@/views/cromis/payments/payment/Payments.vue'),
        meta: {
            pageTitle: 'Payments',
            breadcrumb: [
                {
                    text: 'Process Payments',
                }
            ],
        }
    },

  {
    path: "/levies",
    name: "levies",
    component: () => import("@/views/cromis/levies/Levy.vue"),
    meta: {
      pageTitle: "Payments",
      breadcrumb: [
        {
          text: "Levies",
        },
      ],
    },
  },

  {
    path: "/benefits_payments",
    name: "benefits_payments",
    component: () => import("@/views/cromis/payments/benefits/Benefit.vue"),
    meta: {
      pageTitle: "Payments",
      breadcrumb: [
        {
          text: "Benfits",
        },
      ],
    },
  },

  {
    path: "/institutions",
    name: "institutions",
    component: () => import("@/views/cromis/payableinstitutes/PayableInstitute.vue"),
    meta: {
      pageTitle: "Payments",
      breadcrumb: [
        {
          text: "Payable Institutes",
        },
      ],
    },
  },
{
    path: '/institutions/:id',
    name: 'institutions',
    component: () => import('@/views/cromis/payableinstitutes/InstitutionView.vue'),
    meta: {
        pageTitle: 'View',
        breadcrumb: [
            {
                text: 'Institute',
            },
        ],
    },
},

  {
    path: "/issue_boxes",
    name: "issue_boxes",
    component: () => import("@/views/cromis/inventory/issuing/IssueBox.vue"),
    meta: {
      pageTitle: "Inventory",
      breadcrumb: [
        {
          text: "Boxes Issuing",
        },
      ],
    },
  },
];
